module.exports = __webpack_public_path__ + "img/edit.22cff2d3.svg";